/** Ported from Clarity `apps/web/src/features/domains/utils/frontmatter.ts` (commit `6750a5f43`). */
/**
 * The literals of a Generated file — a domain's auto-generated index artifact — as brain's viewer knows them
 * (`frontmatter.ts:18–26`).
 *
 * Brain mirrors them by hand from its server (`generatedFiles.js` for the basenames, `managedBlock.js` for the
 * markers and the banner), because its web app cannot import across the web/server boundary; this port mirrors brain.
 * A server change to either file reaches this copy only by hand.
 */
export const CLARITY_GENERATED_FILE = {
	/** The marker opening the managed block. */
	BEGIN_MARKER: '<!-- BEGIN GENERATED — DO NOT EDIT below this line -->',
	/** The marker closing the managed block. */
	END_MARKER: '<!-- END GENERATED -->',
	/** The banner line under the opening marker. */
	BANNER: '⚠️ AUTO-GENERATED — do not edit below this line; rebuilt on every file change.',
	/** The only author-editable file that carries an inline managed block. */
	INDEX_BASENAME: 'index.md',
} as const;

/** The reserved auto-generated artifact basenames (brain's `GENERATED_BASENAMES`, mirroring `generatedFiles.js`). */
export const CLARITY_GENERATED_BASENAMES: readonly string[] = ['_concepts.md', '_relations.md', '_backlinks.md'];
